import { render } from "./CalendarTodayIcon.vue?vue&type=template&id=f1b98308"
import script from "./CalendarTodayIcon.vue?vue&type=script&lang=js"
export * from "./CalendarTodayIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__